import { Link } from '@tanstack/react-router'
import { CalendarCheck, Stethoscope, Video } from 'lucide-react'
import { useTranslation } from 'react-i18next'

const CARD_CLASS =
    'group flex flex-1 flex-col gap-4 rounded-3xl border border-slate-100 bg-white p-8 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl'

export const BookingCtaSection = () => {
    const { t } = useTranslation()

    return (
        <section id="booking" className="bg-off-white py-24">
            <div className="mx-auto w-full max-w-[1280px] px-6">
                <div className="mb-12 flex flex-col gap-3 text-center">
                    <h2 className="text-3xl font-bold text-brand-dark md:text-4xl">
                        {t('frontend.home.bookingHeading')}
                    </h2>
                    <p className="mx-auto max-w-2xl text-brand-gray">
                        {t('frontend.home.bookingSubheading')}
                    </p>
                </div>

                <div className="flex flex-col gap-6 md:flex-row">
                    <Link to="/booking/video-consultation" className={CARD_CLASS}>
                        <Video className="h-10 w-10 text-primary" />
                        <h3 className="text-xl font-bold text-brand-dark">
                            {t('frontend.home.bookVideoConsultation')}
                        </h3>
                        <p className="text-sm text-brand-gray">
                            {t('frontend.home.bookVideoConsultationLead')}
                        </p>
                        <span className="mt-auto flex w-full items-center justify-center gap-2 rounded-full bg-primary py-3.5 font-bold text-white transition-all group-hover:bg-brand-dark">
                            {t('frontend.home.bookVideoConsultation')}
                        </span>
                    </Link>

                    <Link to="/booking/examination" className={CARD_CLASS}>
                        <Stethoscope className="h-10 w-10 text-primary" />
                        <h3 className="text-xl font-bold text-brand-dark">
                            {t('frontend.home.bookExamination')}
                        </h3>
                        <p className="text-sm text-brand-gray">
                            {t('frontend.home.bookExaminationLead')}
                        </p>
                        <span className="mt-auto flex w-full items-center justify-center gap-2 rounded-full bg-primary py-3.5 font-bold text-white transition-all group-hover:bg-brand-dark">
                            {t('frontend.home.bookExamination')}
                        </span>
                    </Link>

                    {/*
                     * Webinars are not a service → expert → slot booking: a session is one fixed
                     * slot with one speaker, so this goes to the listing rather than a flow.
                     */}
                    <Link to="/webinars" className={CARD_CLASS}>
                        <CalendarCheck className="h-10 w-10 text-primary" />
                        <h3 className="text-xl font-bold text-brand-dark">
                            {t('frontend.home.browseWebinars')}
                        </h3>
                        <p className="text-sm text-brand-gray">
                            {t('frontend.home.browseWebinarsLead')}
                        </p>
                        <span className="mt-auto flex w-full items-center justify-center gap-2 rounded-full border-2 border-primary py-3.5 font-bold text-primary transition-all group-hover:bg-primary group-hover:text-white">
                            {t('frontend.home.browseWebinars')}
                        </span>
                    </Link>
                </div>
            </div>
        </section>
    )
}
